import React, { PropTypes } from 'react';
import _ from 'lodash';
import cx from 'classnames';

import Input from 'components/forms/Input';




// ====================
// INPUT TEXT
// ====================
export const CheckInput = React.forwardRef(({ type = 'text', className, ...props }, ref) => (
  <Input
    {...props}
    ref={ref}
    className={cx("checkmark", className)}
    renderInput={inputProps => (
      <input type="checkbox" {...inputProps} checked={inputProps.value === true ?? inputProps.value === 'true'} />
    )} />
))
export default CheckInput;
